import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  updateDoc,
  setDoc,
  getDoc,
  documentId,
  writeBatch,
} from "firebase/firestore";
import { db } from "./firebase/firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();
const collectionRsvp = "rsvp";
const collectionSeating = "seating";

const SEATING_PLAN_DOC_IDS = ["plan_part_1", "plan_part_2", "plan_part_3"];

// Create
export async function saveRSVP(data) {
  try {
    await addDocToCollection(collectionRsvp, data);
  } catch (error) {
    console.error("Error saving RSVP: ", error);
  }
}

export const saveTablePlan = async (tables) => {
  const batch = writeBatch(db);

  // Partition tables into three distinct groups based on their tableNumber
  const partitions = [
    tables.filter((t) => t.tableNumber >= 1 && t.tableNumber <= 30),
    tables.filter((t) => t.tableNumber >= 31 && t.tableNumber <= 60),
    tables.filter((t) => t.tableNumber >= 61 && t.tableNumber <= 90),
  ];

  SEATING_PLAN_DOC_IDS.forEach((docId, index) => {
    const planRef = doc(db, collectionSeating, docId);
    const tableChunk = partitions[index]; // Use the correct partition

    // Prepare the data by converting guest objects to IDs
    const planToSave = tableChunk.map((table) => ({
      ...table,
      guests: table.guests.map((g) => g.id),
    }));

    // Set the document with its corresponding partition of tables
    batch.set(planRef, { tables: planToSave });
  });

  await batch.commit();
};

export async function addDocToCollection(collectionName, data) {
  return await addDoc(collection(db, collectionName), data);
}

// Read
export async function fetchRSVPList() {
  try {
    const rsvpCollection = collection(db, collectionRsvp);
    const q = query(rsvpCollection, orderBy("createdAt", "desc"));
    const snapshot = await getDocs(q);
    return snapshot.docs;
  } catch (error) {
    console.error("Error retrieving RSVP: ", error);
  }
}

export const fetchAcceptedRSVPList = async () => {
  const q = query(collection(db, collectionRsvp), where("rsvp", "==", true));
  const querySnapshot = await getDocs(q);
  return querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const fetchTablePlan = async () => {
  // 1. Fetch all 3 plan documents concurrently
  const promises = SEATING_PLAN_DOC_IDS.map((docId) =>
    getDoc(doc(db, collectionSeating, docId))
  );
  const docSnaps = await Promise.all(promises);

  // 2. Combine the 'tables' array from each document
  const savedPlan = docSnaps
    .filter((snap) => snap.exists())
    .flatMap((snap) => snap.data().tables);

  // 3. Return the raw plan with just guest IDs
  return savedPlan.length > 0 ? savedPlan : null;
};

export async function checkIfPhoneNumberExist(contact) {
  const checkPhoneNumber = httpsCallable(functions, "checkIfPhoneNumberExists");
  try {
    const result = await checkPhoneNumber({ phoneNumber: contact });
    const exists = result.data.exists;
    return exists;
  } catch (error) {
    console.error("Error calling checkIfPhoneNumberExist:", error);
    return true;
  }
}

// Update
export const updateRSVP = async (docId, updatedData) => {
  const rsvpDocRef = doc(db, collectionRsvp, docId);
  await updateDoc(rsvpDocRef, updatedData);
};
